import { TelephonyCapabilities } from './telephony-capabilities'

export { TelephonyCapabilities }